import { useCallback, FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { AnyAction } from 'redux';
import {
  changeFilterStore,
  reportFilterCountryCodeSelector,
  reportFilterStoresSelector,
  reportOpStructuresFilterAgreementSelector,
  reportOpStructuresFilterCompanySelector,
  reportOpStructuresFilterManagementSelector,
  reportOpStructuresFilterRegionalManagementSelector,
  reportOpStructuresFilterRegionSelector,
  reportOpStructuresFilterSupervisionSelector,
} from '../../../state';
import { Stores } from '../../../types';
import { StoreSelect } from '../../selects';

interface StoreFilterProps {
  selector?: (...args: any[]) => any;
  action?: (stores: Stores[]) => AnyAction;
}

const StoreFilter: FC<StoreFilterProps> = ({ selector, action }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const changeAction = action || changeFilterStore;
  const countryCode = useSelector(reportFilterCountryCodeSelector);
  const storesSelected = useSelector(selector || reportFilterStoresSelector);
  const regionalManagement = useSelector(reportOpStructuresFilterRegionalManagementSelector);
  const regions = useSelector(reportOpStructuresFilterRegionSelector);
  const managements = useSelector(reportOpStructuresFilterManagementSelector);
  const supervisions = useSelector(reportOpStructuresFilterSupervisionSelector);
  const agreements = useSelector(reportOpStructuresFilterAgreementSelector);
  const companies = useSelector(reportOpStructuresFilterCompanySelector);

  const handleChange = useCallback((value: Stores[]) => dispatch(changeAction(value)), [dispatch]);

  return (
    <StoreSelect
      label={t('toolbar.labels.store')}
      limitTags={3}
      countryCode={countryCode}
      value={storesSelected}
      onChange={handleChange}
      regionalManagements={regionalManagement}
      regions={regions}
      managements={managements}
      supervisions={supervisions}
      agreements={agreements}
      companies={companies}
      selectAll
    />
  );
};

export default StoreFilter;
